import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row>
            <Col md={12} className="text-center">{new Date().getFullYear()} © <a href={process.env.REACT_APP_FRONTEND_URL} target="_blank" rel="noreferrer">Tokenizedgreen.</a></Col>            
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
